<template>
	<el-dialog :title="$t('selectSearchArea')" :visible.sync="dialogVisible" top="5vh" width="600px">
		<div class="dialog-content-wrapper">
			<div class="dialog-image-container">
				<canvas ref="canvas" class="dialog-canvas"></canvas>
				<div class="selection-box" v-if="selectionBox.width > 0" :style="{
					left: selectionBox.x + 'px',
					top: selectionBox.y + 'px',
					width: selectionBox.width + 'px',
					height: selectionBox.height + 'px'
				}">
					<!-- 缩放手柄 -->
					<div class="resize-handle resize-handle-tl" @mousedown.stop="startResize('tl', $event)"></div>
					<div class="resize-handle resize-handle-tr" @mousedown.stop="startResize('tr', $event)"></div>
					<div class="resize-handle resize-handle-bl" @mousedown.stop="startResize('bl', $event)"></div>
					<div class="resize-handle resize-handle-br" @mousedown.stop="startResize('br', $event)"></div>
					<div class="resize-handle resize-handle-t" @mousedown.stop="startResize('t', $event)"></div>
					<div class="resize-handle resize-handle-r" @mousedown.stop="startResize('r', $event)"></div>
					<div class="resize-handle resize-handle-b" @mousedown.stop="startResize('b', $event)"></div>
					<div class="resize-handle resize-handle-l" @mousedown.stop="startResize('l', $event)"></div>
				</div>
			</div>

			<div class="small-image-container" v-if="showSmall">
				<div v-for="item in smallImageList" :key="item.id" class="small-image-item"
					@click="handleSmallImage(item)">
					<img :src="item.base64" style="width: 100px;height: 100px;border-radius: 8px;"
						:style="{'border':item.checked?'2px solid #D9001B':'0'}">
				</div>
			</div>

			<div class="selection-actions">
				<el-button @click="cancelSelection">{{$t('cancelSelect')}}</el-button>
				<el-button @click="confirmSelection" type="primary">{{$t('confirmSelect')}}</el-button>
			</div>
		</div>
	</el-dialog>
</template>

<script>
	import {
		generateSmallImages
	} from '@/utils/searchImage';
	export default {
		name: 'SelectImageSearchArea',
		props: {
			visible: {
				type: Boolean,
				default: false
			},
			selectImage: {
				type: Object,
				default: null
			},
			showSmall: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				thumbnailResults: [],
				// 本地弹窗显示状态
				dialogVisible: this.visible,
				// 图片选择相关
				canvasImage: null,
				selectionBox: {
					x: 0,
					y: 0,
					width: 0,
					height: 0
				},
				isResizing: false,
				isMoving: false,
				resizeType: '',
				startX: 0,
				startY: 0,
				minSelectionSize: 50,
				// 原始图片尺寸
				originalW: 0,
				originalH: 0,
				smallImageList: []
			}
		},
		watch: {
			// 监听 prop 变化，同步到本地状态
			visible: {
				handler(newVal) {
					this.dialogVisible = newVal;
					if (newVal) {
						// 延迟渲染 Canvas，确保 DOM 已更新
						this.$nextTick(() => {
							this.renderImageToCanvas();
							this._generateSmallImages();
						});
					}
				},
				immediate: true
			},
			// 监听本地状态变化，向父组件发送事件
			dialogVisible: {
				handler(newVal) {
					this.$emit('update:visible', newVal);
				}
			}
		},
		methods: {
			// 渲染图片到 Canvas
			renderImageToCanvas() {
				const canvas = this.$refs.canvas;
				if (!canvas) return;

				const ctx = canvas.getContext('2d');
				const img = new Image();

				img.onload = () => {
					// 计算图片缩放比例
					const maxWidth = 500;
					const maxHeight = 500;
					const scale = Math.min(maxWidth / img.width, maxHeight / img.height, 1);

					// 设置 Canvas 尺寸
					canvas.width = img.width * scale;
					canvas.height = img.height * scale;

					// 清空画布
					ctx.clearRect(0, 0, canvas.width, canvas.height);

					// 绘制图片
					ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

					// 保存图片对象
					this.canvasImage = img;

					// 保存原始图片尺寸
					this.originalW = img.width;
					this.originalH = img.height;

					// 设置默认坐标数据（原始图片坐标：x1, x2, y1, y2）
					// 这里可以从 props 或其他地方获取坐标信息，当前使用硬编码的默认值
					let defaultCoords = [];
					if (this.selectImage.region) {
						const region = this.selectImage.region;
						defaultCoords = region.split(',');
					}
					let selectionBox;

					if (defaultCoords && defaultCoords.length === 4) {
						// 如果有传入坐标信息，使用传入的坐标
						const [x1, x2, y1, y2] = defaultCoords;

						// 计算缩放比例
						const scaleX = canvas.width / img.width;
						const scaleY = canvas.height / img.height;

						// 将原始图片坐标转换为 Canvas 显示坐标
						const displayX = Math.round(x1 * scaleX);
						const displayY = Math.round(y1 * scaleY);
						const displayWidth = Math.round((x2 - x1) * scaleX);
						const displayHeight = Math.round((y2 - y1) * scaleY);

						// 确保坐标和尺寸有效
						const finalX = Math.max(0, displayX);
						const finalY = Math.max(0, displayY);
						const finalWidth = Math.max(this.minSelectionSize, Math.min(displayWidth, canvas.width -
							finalX));
						const finalHeight = Math.max(this.minSelectionSize, Math.min(displayHeight, canvas.height -
							finalY));

						// 初始化选框，使用传入的坐标
						selectionBox = {
							x: finalX,
							y: finalY,
							width: finalWidth,
							height: finalHeight
						};

						console.log('使用默认坐标设置:', {
							originalCoords: defaultCoords,
							displayCoords: selectionBox,
							scale: {
								scaleX,
								scaleY
							}
						});
					} else {
						// 如果未传入坐标信息，默认显示：0,200,0,200
						selectionBox = {
							x: 0,
							y: 0,
							width: 200,
							height: 200
						};
					}
					// 初始化选框
					this.selectionBox = selectionBox;
					// 初始化选框事件
					this.initSelectionEvents();
				};
				img.src = this.selectImage.url;
			},
			//生成带有选框的小图
			async _generateSmallImages() {
				const smallImages = await generateSmallImages(this.selectImage);
				this.smallImageList = smallImages;
				if (this.smallImageList.length > 0) {
					this.smallImageList[0].checked = true;
				}
			},
			// 初始化选框事件
			initSelectionEvents() {
				const canvas = this.$refs.canvas;
				if (!canvas) return;

				// 移除之前的事件监听器
				canvas.onmousedown = null;
				canvas.onmousemove = null;
				canvas.onmouseup = null;
				canvas.onmouseleave = null;

				// 鼠标按下事件（用于在画布上创建选框）
				canvas.onmousedown = (e) => {
					const rect = canvas.getBoundingClientRect();
					const x = e.clientX - rect.left;
					const y = e.clientY - rect.top;

					// 检查是否点击在选框内部（移动选框）
					if (x >= this.selectionBox.x && x <= this.selectionBox.x + this.selectionBox.width &&
						y >= this.selectionBox.y && y <= this.selectionBox.y + this.selectionBox.height) {
						this.isMoving = true;
						this.startX = x - this.selectionBox.x;
						this.startY = y - this.selectionBox.y;

						// 鼠标移动事件（全局）
						document.onmousemove = (moveEvent) => {
							if (!this.isMoving) return;

							moveEvent.preventDefault();
							const moveRect = canvas.getBoundingClientRect();
							const moveX = moveEvent.clientX - moveRect.left;
							const moveY = moveEvent.clientY - moveRect.top;

							// 移动选框
							let newX = moveX - this.startX;
							let newY = moveY - this.startY;

							// 边界限制
							newX = Math.max(0, newX);
							newY = Math.max(0, newY);
							newX = Math.min(newX, canvas.width - this.selectionBox.width);
							newY = Math.min(newY, canvas.height - this.selectionBox.height);

							// 更新选框位置
							this.selectionBox.x = newX;
							this.selectionBox.y = newY;
						};

						// 鼠标释放事件（全局）
						document.onmouseup = () => {
							this.isMoving = false;
							document.onmousemove = null;
							document.onmouseup = null;
						};

						// 阻止默认行为和事件冒泡
						e.preventDefault();
						e.stopPropagation();
					}
				};

				// 为选框元素添加 mousedown 事件监听器
				// 这样当用户点击选框内部时，也能触发移动逻辑
				this.$nextTick(() => {
					const selectionBoxEl = document.querySelector('.selection-box');
					if (selectionBoxEl) {
						// 先移除之前的事件监听器，避免重复绑定
						selectionBoxEl.onmousedown = null;

						// 添加新的事件监听器
						selectionBoxEl.onmousedown = (e) => {
							// 检查是否点击在缩放手柄上，如果是则不触发移动逻辑
							const target = e.target;
							if (target.classList.contains('resize-handle')) {
								return;
							}

							const canvas = this.$refs.canvas;
							if (!canvas) return;

							const rect = canvas.getBoundingClientRect();
							const x = e.clientX - rect.left;
							const y = e.clientY - rect.top;

							this.isMoving = true;
							this.startX = x - this.selectionBox.x;
							this.startY = y - this.selectionBox.y;

							// 鼠标移动事件（全局）
							document.onmousemove = (moveEvent) => {
								if (!this.isMoving) return;

								moveEvent.preventDefault();
								const moveRect = canvas.getBoundingClientRect();
								const moveX = moveEvent.clientX - moveRect.left;
								const moveY = moveEvent.clientY - moveRect.top;

								// 移动选框
								let newX = moveX - this.startX;
								let newY = moveY - this.startY;

								// 边界限制
								newX = Math.max(0, newX);
								newY = Math.max(0, newY);
								newX = Math.min(newX, canvas.width - this.selectionBox.width);
								newY = Math.min(newY, canvas.height - this.selectionBox.height);

								// 更新选框位置
								this.selectionBox.x = newX;
								this.selectionBox.y = newY;
							};

							// 鼠标释放事件（全局）
							document.onmouseup = () => {
								this.isMoving = false;
								document.onmousemove = null;
								document.onmouseup = null;
							};

							// 阻止默认行为和事件冒泡
							e.preventDefault();
							e.stopPropagation();
						};
					}
				});
			},
			// 开始缩放选框
			startResize: function(type, e) {
				this.isResizing = true;
				this.resizeType = type;
				const canvas = this.$refs.canvas;
				const rect = canvas.getBoundingClientRect();
				this.startX = e.clientX - rect.left;
				this.startY = e.clientY - rect.top;

				// 鼠标移动事件（全局）
				document.onmousemove = (moveEvent) => {
					if (!this.isResizing) return;

					moveEvent.preventDefault();
					const moveRect = canvas.getBoundingClientRect();
					const moveX = moveEvent.clientX - moveRect.left;
					const moveY = moveEvent.clientY - moveRect.top;

					// 缩放选框
					this.resizeSelection(moveX, moveY);
				};

				// 鼠标释放事件（全局）
				document.onmouseup = () => {
					this.isResizing = false;
					document.onmousemove = null;
					document.onmouseup = null;
				};

				// 阻止事件冒泡
				e.preventDefault();
				e.stopPropagation();
			},
			// 缩放选框
			resizeSelection: function(x, y) {
				const canvas = this.$refs.canvas;
				if (!canvas) return;

				let newX = this.selectionBox.x;
				let newY = this.selectionBox.y;
				let newWidth = this.selectionBox.width;
				let newHeight = this.selectionBox.height;

				// 根据缩放类型调整选框
				switch (this.resizeType) {
					case 'tl': // 左上角
						newX = x;
						newY = y;
						newWidth = this.selectionBox.x + this.selectionBox.width - x;
						newHeight = this.selectionBox.y + this.selectionBox.height - y;
						break;
					case 'tr': // 右上角
						newY = y;
						newWidth = x - this.selectionBox.x;
						newHeight = this.selectionBox.y + this.selectionBox.height - y;
						break;
					case 'bl': // 左下角
						newX = x;
						newWidth = this.selectionBox.x + this.selectionBox.width - x;
						newHeight = y - this.selectionBox.y;
						break;
					case 'br': // 右下角
						newWidth = x - this.selectionBox.x;
						newHeight = y - this.selectionBox.y;
						break;
					case 't': // 顶部
						newY = y;
						newHeight = this.selectionBox.y + this.selectionBox.height - y;
						break;
					case 'r': // 右侧
						newWidth = x - this.selectionBox.x;
						break;
					case 'b': // 底部
						newHeight = y - this.selectionBox.y;
						break;
					case 'l': // 左侧
						newX = x;
						newWidth = this.selectionBox.x + this.selectionBox.width - x;
						break;
				}

				// 确保选框尺寸为正
				if (newWidth < 0) {
					newX = this.selectionBox.x + this.selectionBox.width;
					newWidth = -newWidth;
				}
				if (newHeight < 0) {
					newY = this.selectionBox.y + this.selectionBox.height;
					newHeight = -newHeight;
				}

				// 边界限制
				newX = Math.max(0, newX);
				newY = Math.max(0, newY);
				newWidth = Math.min(newWidth, canvas.width - newX);
				newHeight = Math.min(newHeight, canvas.height - newY);

				// 最小尺寸限制
				newWidth = Math.max(newWidth, this.minSelectionSize);
				newHeight = Math.max(newHeight, this.minSelectionSize);

				// 更新选框
				this.selectionBox = {
					x: newX,
					y: newY,
					width: newWidth,
					height: newHeight
				};
			},
			// 确认选择
			confirmSelection() {
				if (this.selectionBox.width <= 0 || this.selectionBox.height <= 0) {
					this.$message.warning('请先选择一个区域');
					return;
				}

				// 获取选框数据
				const selectionData = this.getSelectionData();
				var callbackData = this.generateThumbnail();
				callbackData.key = this.selectImage.key;
				callbackData.region = selectionData.coordsString;

				// 触发确认事件
				this.$emit('confirm', callbackData);
				// 关闭弹窗
				this.dialogVisible = false;
			},
			// 取消选择
			cancelSelection() {
				this.$emit('cancel');
				// 关闭弹窗
				this.dialogVisible = false;
			},
			// 获取选框数据
			getSelectionData() {
				try {
					const canvas = this.$refs.canvas;
					if (!canvas) return null;

					// 计算选择框的实际宽度和高度
					const cropWidth = this.selectionBox.width;
					const cropHeight = this.selectionBox.height;

					// 计算缩放比例
					const scaleX = this.originalW / canvas.width;
					const scaleY = this.originalH / canvas.height;

					// 计算在原始图片上的坐标
					const x1 = Math.round(this.selectionBox.x * scaleX);
					const x2 = Math.round((this.selectionBox.x + cropWidth) * scaleX);
					const y1 = Math.round(this.selectionBox.y * scaleY);
					const y2 = Math.round((this.selectionBox.y + cropHeight) * scaleY);

					// 确保坐标在有效范围内
					const finalX1 = Math.max(0, Math.min(x1, this.originalW));
					const finalX2 = Math.max(finalX1 + 1, Math.min(x2, this.originalW));
					const finalY1 = Math.max(0, Math.min(y1, this.originalH));
					const finalY2 = Math.max(finalY1 + 1, Math.min(y2, this.originalH));

					// 生成与 region-selector.vue 相同格式的坐标字符串
					const regionCoords = `${finalX1},${finalX2},${finalY1},${finalY2}`;

					console.log('显示坐标:',
						`(${this.selectionBox.x},${this.selectionBox.x + cropWidth},${this.selectionBox.y},${this.selectionBox.y + cropHeight})`
					);
					console.log('实际坐标:', `(${finalX1},${finalX2},${finalY1},${finalY2})`);
					console.log('缩放比例:', {
						scaleX,
						scaleY
					});

					return {
						x: this.selectionBox.x,
						y: this.selectionBox.y,
						width: this.selectionBox.width,
						height: this.selectionBox.height,
						// 添加原始图片坐标和坐标字符串
						originalCoords: {
							x1: finalX1,
							x2: finalX2,
							y1: finalY1,
							y2: finalY2
						},
						coordsString: regionCoords
					};
				} catch (error) {
					console.error('获取区域坐标失败:', error);
					return {
						x: this.selectionBox.x,
						y: this.selectionBox.y,
						width: this.selectionBox.width,
						height: this.selectionBox.height
					};
				}
			},
			// 生成缩略图
			generateThumbnail() {
				const canvas = this.$refs.canvas;
				if (!canvas) return;

				// 创建临时 Canvas 用于生成缩略图
				const tempCanvas = document.createElement('canvas');
				const tempCtx = tempCanvas.getContext('2d');

				// 设置缩略图尺寸
				tempCanvas.width = 100;
				tempCanvas.height = 100;

				// 绘制选中区域到缩略图
				tempCtx.drawImage(
					canvas,
					this.selectionBox.x,
					this.selectionBox.y,
					this.selectionBox.width,
					this.selectionBox.height,
					0,
					0,
					100,
					100
				);

				// 获取缩略图的 base64 数据（已转换为图片显示地址格式）
				const thumbnailBase64 = tempCanvas.toDataURL('image/jpeg');

				// 创建临时 Canvas 用于生成带有选框的图片
				const canvasWithSelection = document.createElement('canvas');
				const ctxWithSelection = canvasWithSelection.getContext('2d');

				// 设置 Canvas 尺寸与原图相同
				canvasWithSelection.width = canvas.width;
				canvasWithSelection.height = canvas.height;

				// 绘制完整的原图
				ctxWithSelection.drawImage(canvas, 0, 0, canvas.width, canvas.height);

				// 在原图上绘制选框
				// 先绘制半透明背景
				ctxWithSelection.fillStyle = 'rgba(1, 106, 248, 0.2)';
				ctxWithSelection.fillRect(
					this.selectionBox.x,
					this.selectionBox.y,
					this.selectionBox.width,
					this.selectionBox.height
				);
				// 再绘制实线边框
				ctxWithSelection.strokeStyle = '#016AF8';
				ctxWithSelection.lineWidth = 2;
				// 移除虚线设置，使用实线
				ctxWithSelection.strokeRect(
					this.selectionBox.x,
					this.selectionBox.y,
					this.selectionBox.width,
					this.selectionBox.height
				);

				// 获取带有选框的图片的 base64 数据
				const imageWithSelectionBase64 = canvasWithSelection.toDataURL('image/jpeg');

				return {
					thumbnailBase64,
					imageWithSelectionBase64
				};
			},
			// 处理鼠标释放事件
			handleMouseUp: function() {
				this.isMoving = false;
				this.isResizing = false;

				// 确保选框最小尺寸
				if (this.selectionBox.width < this.minSelectionSize || this.selectionBox.height < this
					.minSelectionSize) {
					this.selectionBox.width = Math.max(this.selectionBox.width, this.minSelectionSize);
					this.selectionBox.height = Math.max(this.selectionBox.height, this.minSelectionSize);

					// 再次检查边界
					const canvas = this.$refs.canvas;
					if (canvas) {
						this.selectionBox.x = Math.max(0, Math.min(this.selectionBox.x, canvas.width - this
							.selectionBox.width));
						this.selectionBox.y = Math.max(0, Math.min(this.selectionBox.y, canvas.height - this
							.selectionBox.height));
					}
				}
			},
			//小图的选中事件
			handleSmallImage(row) {
				this.smallImageList.map(item => {
					item.checked = false;
				})
				row.checked = true;
				this.selectImage.region = row.region;
				this.renderImageToCanvas();
				console.log(this.smallImageList)
			},
		}
	}
</script>

<style scoped>
	.small-image-container {
		display: flex;
		width: 500px;
	}

	.small-image-item {
		margin-right: 10px;
		cursor: pointer;
	}

	.dialog-content-wrapper {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 20px;
	}

	.dialog-image-container {
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #f5f7fa;
		border-radius: 4px;
	}

	.dialog-canvas {
		max-width: 500px;
		max-height: 500px;
		cursor: crosshair;
	}

	.selection-box {
		position: absolute;
		border: 2px solid #016AF8;
		background-color: rgba(1, 106, 248, 0.2);
		cursor: move;
		z-index: 10;
		pointer-events: auto;
	}

	.resize-handle {
		position: absolute;
		width: 8px;
		height: 8px;
		background-color: #016AF8;
		border: 1px solid white;
		cursor: pointer;
	}

	.resize-handle-tl {
		top: -4px;
		left: -4px;
		cursor: nwse-resize;
	}

	.resize-handle-tr {
		top: -4px;
		right: -4px;
		cursor: nesw-resize;
	}

	.resize-handle-bl {
		bottom: -4px;
		left: -4px;
		cursor: nesw-resize;
	}

	.resize-handle-br {
		bottom: -4px;
		right: -4px;
		cursor: nwse-resize;
	}

	.resize-handle-t {
		top: -4px;
		left: 50%;
		transform: translateX(-50%);
		cursor: ns-resize;
	}

	.resize-handle-r {
		right: -4px;
		top: 50%;
		transform: translateY(-50%);
		cursor: ew-resize;
	}

	.resize-handle-b {
		bottom: -4px;
		left: 50%;
		transform: translateX(-50%);
		cursor: ns-resize;
	}

	.resize-handle-l {
		left: -4px;
		top: 50%;
		transform: translateY(-50%);
		cursor: ew-resize;
	}

	.selection-actions {
		z-index: 100;
		padding: 10px;
		border-radius: 4px;
		width: 100%;
		max-width: 500px;
		display: flex;
		justify-content: center;
		gap: 5px;
	}
</style>